import { PublicClientApplication } from '@azure/msal-browser';
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID ?? '5b973f99-77df-4beb-b27d-aa0c70b8482c';
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID ?? '0b97b051-10e8-4cf6-b56d-cc24aaf50fe4';
export const loginScopes = (import.meta.env.VITE_ENTRA_SCOPES ?? 'openid profile email')
    .split(',')
    .map((scope) => scope.trim())
    .filter(Boolean);
export const msalConfig = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: import.meta.env.VITE_ENTRA_REDIRECT_URI ?? window.location.origin,
        postLogoutRedirectUri: import.meta.env.VITE_ENTRA_POST_LOGOUT_REDIRECT_URI ?? window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
};
export const msalInstance = new PublicClientApplication(msalConfig);
